import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { InsuranceImagesComponent } from '@app/shared/insurance/insurance-images/insurance-images.component';
import { RouterModule } from '@angular/router';
import { InsuranceImagesContainer } from '@app/shared/insurance/insurance-images/insurance-images.container';

@NgModule({
  declarations: [InsuranceImagesComponent, InsuranceImagesContainer],
    imports: [
        CommonModule,
        RouterModule
    ],
    exports: [InsuranceImagesContainer]
})
export class InsuranceImagesModule { }
